import { render } from "./DialogSettings.vue?vue&type=template&id=06e1c41d&scoped=true"
import script from "./DialogSettings.vue?vue&type=script&lang=js"
export * from "./DialogSettings.vue?vue&type=script&lang=js"

import "./DialogSettings.vue?vue&type=style&index=0&id=06e1c41d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e1c41d"]])

export default __exports__